import { motion } from "framer-motion";
import iconBlue from "../../assets/iconBlue.svg";

export default function WhoAreWeSection() {
	return (
		<section className="flex flex-col md:flex-row justify-center items-center gap-10 py-10 px-6 md:px-16 bg-white overflow-hidden">
			<motion.div
				initial={{ x: -150, opacity: 0 }}
				whileInView={{ x: 0, opacity: 1 }}
				transition={{ duration: 0.8, ease: "easeInOut" }}
				viewport={{ once: true }}
				className="flex-1 flex justify-center"
			>
				<img
					src={iconBlue}
					alt="Icono corporativo"
					className="w-64 h-auto rounded-2xl shadow-lg"
				/>
			</motion.div>
			<motion.div
				initial={{ x: 150, opacity: 0 }}
				whileInView={{ x: 0, opacity: 1 }}
				transition={{ duration: 0.8, ease: "easeOut" }}
				viewport={{ once: true }}
				className="flex-1 text-center md:text-left"
			>
				<h2 className="text-3xl font-bold text-gray-800 mb-4">
					¿Quiénes Somos?
				</h2>
				<p className="text-gray-800">
					Somos una empresa comprometida en brindar el mejor servicio en la
					renta de autos para ejecutivos en Puebla con nuestros vehículos en
					excelente estado. Además del interés en servir de todo nuestro
					personal capacitado y guiado por un espíritu Humano y el mayor respeto
					hacia nuestros clientes y sus reservaciones.
				</p>
			</motion.div>
		</section>
	);
}
